<template>
  <div
    v-if="user"
    class="content-container"
  >
    <img
      :src="computedSrc"
      alt="user-profile-pict"
      width="160px"
      height="160px"
      class="mb-4 rounded-circle"
    >
    <h2 class="wrap-text">
      {{ computedGreeting }}
    </h2>
    <span class="mb-5">{{ welcomeInfo.dailyLogin.message }}</span>
    <button
      type="button"
      class="action-btn vs-btn close-welcome-modal-btn"
      @click="closeModal"
    >
      Close
    </button>
  </div>
  <div
    v-else
    class="p-6 text-center"
  >
    Loading...
  </div>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue';
import debounce from 'lodash/debounce';
import initialGenerator from '@/scripts/helpers/initial-generator';
import { UserInfoCompat } from '@/scripts/libs/login/userResponseProcessor';
import { WelcomeInfo } from '@/../../packages/@viddsee/server-api-client/types/models/info';

export default Vue.extend({
  props: {
    user: {
      type: Object as PropType<UserInfoCompat>,
      required: true,
    },
    closeModal: {
      type: Function,
      default: (): void => void 0,
    },
    welcomeInfo: {
      type: Object as PropType<WelcomeInfo>,
      required: true,
    },
  },
  data() {
    return {
      initialSrc: '',
      renderDebouncer: (): void => void 0,
    };
  },
  computed: {
    computedSrc(): string {
      if (this.user.profile.profileImageUrl) return this.user.profile.profileImageUrl;
      return this.initialSrc;
    },
    computedGreeting(): string {
      return this.welcomeInfo.dailyLogin.greeting.replace('{name}', this.user.profile.firstName);
    },
  },
  watch: {
    name(): void { this.renderDebouncer && this.renderDebouncer(); },
  },
  mounted() {
    this.renderInitial();
    this.renderDebouncer = debounce(this.renderInitial, 500);
  },
  methods: {
    renderInitial(): void {
      this.initialSrc = initialGenerator.make({
        name: this.user.profile.firstName.trim() || 'N',
      });
    },
  },

});
</script>

<style lang="scss">
@import '~@/stylesheets/exports/_component-entry';

.content-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: linear-gradient($primary 40%, white 0);
  border-radius: 4px;
  padding: 128px 16px 40px 16px
}

.wrap-text {
  max-width: 90%;
  overflow: hidden;
  text-overflow: ellipsis;
  text-wrap: nowrap;
}

.action-btn {
  font-family: $font-family-base;
  font-weight: initial;
  border-radius: 4px;
  background-color: $primary;
  color: white;
  vertical-align: middle;
  text-align: center !important;
  padding:8px 12px;
}

</style>
